module.exports = __webpack_public_path__ + "static/img/jc_zt_sec4_img1.a6e635e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/jc_zt_sec4_img1.gif
// module id = krSd
// module chunks = 171